document.addEventListener('DOMContentLoaded', function() {
  fixSaleTags();
  fixWishlistButtons();
  fixRecentlyViewed();
  fixProductSpacing();
  
  setTimeout(fixSaleTags, 500);
  
  const observer = new MutationObserver(function() {
    fixSaleTags();
    fixWishlistButtons();
    fixProductSpacing();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  function fixSaleTags() {
    const saleTags = document.querySelectorAll('.grid-product__tag--sale, #rea-sale-tag');
    
    saleTags.forEach(function(tag) {
      tag.style.cssText = `
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        background-color: #f2e9f5 !important;
        color: #a076af !important;
        padding: 3px 8px !important;
        font-size: 11px !important;
        border-radius: 0 !important;
        text-transform: uppercase !important;
        margin-left: auto !important;
        white-space: nowrap !important;
        font-weight: 600 !important;
        letter-spacing: 0.5px !important;
        z-index: 99999 !important;
        position: relative !important;
      `;
      
      const priceContainer = tag.closest('.grid-product__price-sale');
      if (priceContainer) {
        priceContainer.style.cssText = `
          display: flex !important;
          flex-direction: row !important;
          justify-content: space-between !important;
          align-items: center !important;
          width: 100% !important;
          visibility: visible !important;
          opacity: 1 !important;
          z-index: 999 !important;
        `;
      }
    });
  }
  
  function fixWishlistButtons() {
    const wishlistButtons = document.querySelectorAll('.grid-wishlist-icon');
    const wishlistContainers = document.querySelectorAll('.grid-product__wishlist-container');
    
    wishlistContainers.forEach(function(container) {
      container.style.cssText = `
        display: flex !important;
        align-items: center !important;
        justify-content: flex-end !important;
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
        z-index: 3 !important;
      `;
    });
    
    wishlistButtons.forEach(function(button) {
      button.style.cssText = `
        background: transparent !important;
        border: none !important;
        padding: 2px !important;
        cursor: pointer !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      `;
      
      const svg = button.querySelector('svg');
      if (svg) {
        svg.style.cssText = `
          width: 16px !important;
          height: 16px !important;
          color: #999999 !important;
        `;
      }
    });
  }
  
  function fixRecentlyViewed() {
    const aggressiveLinks = document.querySelectorAll('[data-recently-viewed-link="true"]');
    aggressiveLinks.forEach(function(link) {
      link.removeAttribute('data-recently-viewed-link');
    });
  }
  
  function fixProductSpacing() {
    const infoContainers = document.querySelectorAll('.grid-product__info-container');
    
    infoContainers.forEach(function(container) {
      container.style.cssText = `
        display: flex !important;
        flex-direction: column !important;
        gap: 0 !important;
        padding: 4px 5px 6px 5px !important;
      `;
      
      const title = container.querySelector('.grid-product__title');
      if (title) {
        title.style.marginBottom = '2px !important';
      }
    });
    
    const priceElements = document.querySelectorAll('.grid-product__price--current, .grid-product__price--original');
    priceElements.forEach(function(price) {
      price.style.cssText = `
        font-size: 13px !important;
        font-weight: normal !important;
        margin: 0 !important;
      `;
    });
  }
});